import type { HealthPlanDependentState } from '../../../../../shared/dpRequests';

interface DependentChecklistProps {
    legend: string;
    dependents: HealthPlanDependentState[];
    selected: string[];
    onToggle: (name: string) => void;
    emptyText: string;
    disabled?: boolean;
}

export function DependentChecklist({ legend, dependents, selected, onToggle, emptyText, disabled = false }: DependentChecklistProps) {
    return (
        <fieldset className="space-y-2" disabled={disabled}>
            <legend className="text-sm font-semibold text-raro-gray-800">{legend}</legend>
            {dependents.length === 0 ? (
                <p className="text-sm text-raro-gray-500">{emptyText}</p>
            ) : (
                <ul className="space-y-2">
                    {dependents.map(dependent => (
                        <li key={`${dependent.relationship}-${dependent.name}`}>
                            <label className="flex cursor-pointer items-center gap-3 rounded-xl border border-raro-gray-200 bg-white px-3 py-2 text-sm text-raro-gray-800">
                                <input
                                    type="checkbox"
                                    checked={selected.includes(dependent.name)}
                                    onChange={() => onToggle(dependent.name)}
                                    className="h-4 w-4 rounded border-raro-gray-300 text-primary-600 focus:ring-primary-500"
                                />
                                <span>{dependent.name}</span>
                                <span className="text-xs text-raro-gray-500">{dependent.relationship}</span>
                            </label>
                        </li>
                    ))}
                </ul>
            )}
        </fieldset>
    );
}
